<script setup lang="ts">
import { defineProps, defineEmits } from "vue";

type Props = {
  title?: string;
  data?: any;
  tableName: string;
};
type Emits = {
  (
    event: "onChangeInput",
    tableName: string,
    rowId: any,
    inputId: any,
    value: any
  ): void;
  (
    event: "onChangeColumn",
    tableName: string,
    columnId: number,
    value: any
  ): void;
  (event: "addRow", tableName: string): void;
};

defineEmits<Emits>();
defineProps<Props>();
</script>
<template>
  <div class="flex flex-col">
    <div class="flex flex-col">
      <!-- header v1 -->
      <div v-if="tableName !== 'stromkreis'" class="flex">
        <div
          class="bg-[#f9f8f6] border border-[#e3e1ea] p-3 flex items-center w-[200px] min-h-[44px] text-base font-semibold text-[#393840]"
        >
          Stromkreis
        </div>
        <div
          class="w-[900px] bg-[#f9f8f6] border border-[#e3e1ea] p-3 flex items-center min-h-[44px] text-base font-semibold text-[#393840]"
        >
          Fehlerstrom-Schutzeinrichtung (RCD)
        </div>
      </div>
      <!-- header v2 -->
      <div v-if="tableName === 'stromkreis'" class="flex">
        <div
          class="bg-[#f9f8f6] border border-[#e3e1ea] p-3 flex items-center w-[200px] min-h-[44px] text-base font-semibold text-[#393840]"
        >
          Stromkreis
        </div>
        <div
          class="bg-[#f9f8f6] border border-[#e3e1ea] p-3 flex items-center w-[300px] min-h-[44px] text-base font-semibold text-[#393840]"
        >
          Leitung/Kabel
        </div>
        <div
          class="w-[450px] bg-[#f9f8f6] border border-[#e3e1ea] p-3 flex items-center min-h-[44px] text-base font-semibold text-[#393840]"
        >
          Überstrom-Schutzeinrichtung
        </div>
        <div
          class="w-[150px] bg-[#f9f8f6] border border-[#e3e1ea] p-3 flex items-center min-h-[44px] text-base font-semibold text-[#393840]"
        >
          Riso (MΩ)
        </div>
      </div>
      <div class="flex">
        <div v-for="(item, index) in data[0]" :key="item" class="flex">
          <div
            class="flex items-center"
            :class="`${index === 0 ? 'w-[50px]' : 'w-[150px]'} ${
              index !== 6 && index !== 7
                ? 'py-5 px-2 border border-[#e3e1ea]'
                : ''
            }`"
          >
            <span v-if="index !== 6 && index !== 7"> {{ item.text }}</span>
            <textarea
              :name="item.id"
              @change="(event:any)=> $emit('onChangeColumn',tableName,item.id, event.target.value)"
              :value="item.text"
              v-if="index === 6 || index === 7"
              class="resize-none py-5 px-2 border border-[#e3e1ea] flex items-center w-[150px] h-full"
            />
          </div>
        </div>
      </div>
      <div class="flex flex-col">
        <div v-for="(row, rowIndex) in data" :key="row" class="flex h-full">
          <div v-for="(item, columnIndex) in row" :key="item">
            <div
              class="py-5 px-2 border border-[#e3e1ea] flex items-center w-[50px] h-full"
              v-if="columnIndex === 0"
            >
              {{ rowIndex + 1 }}
            </div>
            <input
              :name="item.id"
              :value="item.value"
              @change="(event:any)=> $emit('onChangeInput',tableName,rowIndex,item.id,event.target.value)"
              v-if="columnIndex !== 0"
              class="py-5 px-2 border border-[#e3e1ea] flex items-center w-[150px] h-full"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      class="hover:cursor-pointer mt-4 w-[1100px] flex justify-center"
      @click="$emit('addRow', tableName)"
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 10C1 14.9706 5.02944 19 10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10Z"
          fill="white"
        />
        <path
          d="M6 10H10M10 10H14M10 10V14M10 10V6M10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10C19 14.9706 14.9706 19 10 19Z"
          stroke="#393840"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  </div>
</template>
